<template>
  <div class="mt-1">
    <b-card-text class="mb-25">
      {{ client ? ((client.otherName || "") + " " + (client.surname || "")) : "" }}

    </b-card-text>
    <b-card-text class="mb-25">
      {{ this.getAddress }}
    </b-card-text>
    <b-card-text class="mb-25">
      {{ client ? client.city : "" }}
    </b-card-text>
    <b-card-text class="mb-25">
      {{ client ? client.tel : "" }}
    </b-card-text>
    <b-card-text class="mb-0">
      {{ client ? client.email : "" }}
    </b-card-text>
  </div>
</template>

<script>
import { BRow, BCol, BCardText } from "bootstrap-vue";

export default {
  name: "Logo",
  props: {
    client: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    BRow,
    BCol,
    BCardText,
  },
  data() {
    return {
      tenantData: [],
      userData: localStorage.getItem("userData"),
    };
  },

  computed: {
    getAddress() {
      var address = "";

      if (this.client) {
        address =
          (this.client.addressLine1 == null ? "" : this.client.addressLine1) +
          " " +
          (this.client.addressLine2 == null ? "" : this.client.addressLine2);
      }

      return address;
    },
  },

  mounted() {
    this.tenantData = JSON.parse(localStorage.getItem("userData"));
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>